import { Form, Offcanvas, Button } from "react-bootstrap";

const AdvanceConsentForm = ({
  show,
  hide,
  title,
  initialConsentSettings,
  widgetConsentSettings,
  widgetConsentChangeSettings,
  setWidgetConsentSettings
}) => {
  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          {/* Require Consent */}
          <Form.Group className="mb-3">
            <Form.Label>Require consent form</Form.Label>
            <Form.Select
              size="sm"
              name="requireConsent"
              value={widgetConsentSettings?.requireConsent}
              onChange={widgetConsentChangeSettings}
            >
              <option value="disabled">Disabled</option>
              <option value="everyone">Everyone</option>
            </Form.Select>
          </Form.Group>

          {/* Message */}
          <Form.Group className="mb-3">
            <Form.Label>Consent message</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              name="consentMessage"
              value={widgetConsentSettings?.consentMessage}
              onChange={widgetConsentChangeSettings}
              placeholder="Hello! We would love to talk to you..."
            />
          </Form.Group>

          {/* Privacy Link */}
          <Form.Group className="mb-3">
            <Form.Label>Privacy policy link (Optional)</Form.Label>
            <Form.Control
              type="url"
              name="privacyLink"
              value={widgetConsentSettings?.privacyLink}
              onChange={widgetConsentChangeSettings}
              placeholder="Enter Privacy policy link"
            />
          </Form.Group>

          {/* Privacy Text */}
          <Form.Group className="mb-3">
            <Form.Label>Privacy policy Text (Optional)</Form.Label>
            <Form.Control
              type="text"
              name="privacyText"
              value={widgetConsentSettings?.privacyText}
              onChange={widgetConsentChangeSettings}
              placeholder="Enter Privacy policy Text"
            />
          </Form.Group>

          {/* Opt In */}
          <Form.Group className="mb-3">
            <Form.Label>Opt-In Button</Form.Label>
            <Form.Control
              type="text"
              name="optInText"
              value={widgetConsentSettings?.optInText}
              onChange={widgetConsentChangeSettings}
              placeholder="I Accept"
            />
          </Form.Group>

          {/* Opt Out */}
          <Form.Group className="mb-3">
            <Form.Label>Opt-Out Button</Form.Label>
            <Form.Control
              type="text"
              name="optOutText"
              value={widgetConsentSettings?.optOutText}
              onChange={widgetConsentChangeSettings}
              placeholder="Not Now"
            />
          </Form.Group>
          {(widgetConsentSettings?.requireConsent === "everyone") &&
            <div className="d-flex justify-content-end gap-2 mt-3">
              <Button
                style={{ fontSize: 12 }}
                variant="outline-danger"
                onClick={(e) => setWidgetConsentSettings(initialConsentSettings)}
              >
                Resent
              </Button>
            </div>
          }
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AdvanceConsentForm;
